module.exports = __webpack_public_path__ + "img/result.41cb0a9c.png";